export default __webpack_public_path__ + "static/media/cloud_logo.31c82788.png";